import React from "react";
import { Container, Row, Col, Button } from "reactstrap";
import { useHistory } from "react-router-dom";

const PageNotFound = () => {
  const history = useHistory();

  return (
    <div
      className="d-flex align-items-center justify-content-center"
      style={{
        minHeight: "100vh",
        backgroundColor: "#f8f9fa",
      }}
    >
      <Container>
        <Row className="justify-content-center">
          <Col md={6} className="text-center">
            {/* Ikon atau Gambar */}
            <div className="mb-4">
              <h1
                style={{
                  fontSize: "120px",
                  fontWeight: "bold",
                  color: "#dee2e6",
                  marginBottom: "-20px",
                }}
              >
                404
              </h1>
            </div>

            {/* Teks Pesan */}
            <h2 className="fw-bold text-dark mb-3">Data Tidak Ditemukan</h2>
            <p className="text-muted mb-5 px-md-5">
              Maaf, tautan pendaftaran yang Anda akses tidak valid, sudah
              kadaluwarsa, atau mungkin telah dihapus oleh admin desa.
            </p>

            {/* Tombol Aksi */}
            <div className="d-grid gap-2 d-sm-flex justify-content-sm-center">
              <Button
                color="primary"
                size="lg"
                className="px-4 shadow-sm"
                onClick={() => history.push("/")}
                style={{ borderRadius: "10px" }}
              >
                🏠 Kembali ke Beranda
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default PageNotFound;
